import React from "react";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import QRCode from "qrcode.react";
import TextBtn from "../TextBtn";
import BookingDetailList from "../BookingDetailList";
import "./style.scss";
import upArrow from "../../images/icons/up-arrow.png";
import downArrow from "../../images/icons/down-arrow.png";

const RTEAppointment = ({appointmentsDetails, menuHandler, infoHandler}) => {
  const {t} = useTranslation();

  const {appndetails, qrResp, selectedAppn} = useSelector((state) => {
    return {
      appndetails: state.appnDetails.appnData,
      qrResp: state.appnDetails.apiResponse,
      selectedAppn: state.appnDetails.selectedAppn,
    };
  });
  const handleExpand = (app) => {
    infoHandler(app);
  };

  if (!appointmentsDetails || appointmentsDetails.length === 0) {
    return (
      <div className="no-bookings-page">
        <div className="add-teams-illustration"></div>
        <div className="no-bookings-text">{t("emptyReservations")}</div>
      </div>
    );
  }

  return (
    <>
      <div className="accordion-add-scroll">
        {appointmentsDetails.map((appointment) => (
          <div key={appointment.uuid}>
            {appointment.uuid !== selectedAppn ? (
              <>
                <div
                  className="accordion-minimised"
                  onClick={() => {
                    handleExpand(appointment);
                  }}
                >
                  <label className="accordion-storeName">
                    Reserva {appointment.storeName}
                    {appointment.status === "cancelled_by_admin" ? (
                      <span className="admin-cancelled">
                        <sup>*</sup>
                        {`${t("note")}: ${t("cancel")}`}
                      </span>
                    ) : (
                      ""
                    )}
                  </label>

                  <img src={downArrow} alt="click" />
                </div>
              </>
            ) : (
              <>
                <div
                  className="accordion-maximised"
                  onClick={() => {
                    handleExpand(appointment);
                  }}
                >
                  <div className="accordion-header">
                    <label className="accordion-storeName">
                      Reserva {appointment.storeName}
                      {appointment.status === "cancelled_by_admin" ? (
                        <span className="admin-cancelled">
                          <sup>*</sup>
                          {`${t("note")}: ${t("cancel")}`}
                        </span>
                      ) : (
                        ""
                      )}
                    </label>
                    {appointmentsDetails.length === 1 ? (
                      ""
                    ) : (
                      <img src={upArrow} alt="click" />
                    )}
                  </div>
                  <div className="accordion-content">
                    <div className="accordion-maximised-details">
                      <BookingDetailList
                        endTime={appndetails.endTime}
                        isOffice={true}
                        region={appndetails.location}
                        serviceType={appndetails.serviceType.toString()}
                        startTime={appndetails.startTime}
                        storeName={appndetails.storeName}
                        timeZone={appndetails.timeZone}
                        country={appndetails.country}
                        bu={appndetails.businessUnit}
                      />
                    </div>
                    <div style={{textAlign: "center"}}>
                      <div className="flex">
                        {
                          <QRCode
                            id="slotbook-qrcode"
                            value={
                              appointment.status !== "cancelled_by_admin"
                                ? qrResp
                                : ""
                            }
                            renderAs={"png"}
                            className={`qr-code
                              ${
                                appointment.status === "cancelled_by_admin"
                                  ? "qr-disabled"
                                  : ""
                              }`}
                            size={256}
                          />
                        }
                        {appointment.status === "cancelled_by_admin" ? (
                          <div className="cancelled-text">
                            {t("cancelled-text-admin")}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      {appointment.status !== "cancelled_by_admin" ? (
                        <div className="cancel-reservation-btn">
                          <TextBtn
                            name={t("cancel.reservation.title")}
                            handleClick={() => {
                              menuHandler(appointment);
                            }}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default RTEAppointment;
